import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { InputsComponent } from './components/inputs/inputs.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStep, MatStepperModule } from '@angular/material/stepper';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormbuilderComponent } from './components/formbuilder/formbuilder/formbuilder.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { TableComponent } from './components/table/table.component';
import { MatIcon } from "@angular/material/icon";
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChip, MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ActionModalComponent } from './components/action-modal/action-modal.component';
import { FooterComponent } from './components/footer/footer.component';
import { CoreModule } from '../core/core.module';
import { FormSummaryComponent } from './components/form-summary/form-summary.component';
import { AttachmentsListComponent } from './components/attachments-list/attachments-list.component';
import { ServiceDescriptionComponent } from './components/service-description/service-description.component';
import { ReviewWorkflowComponent } from './components/review-workflow/review-workflow.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ExpressionOfInterestModalComponent } from './components/expression-of-interest-modal/expression-of-interest-modal.component';




const components = [
  ButtonComponent,
  InputsComponent,
  FormbuilderComponent,
  FilePreviewComponent,
  TableComponent,
  ActionModalComponent,
  FooterComponent,
  FormSummaryComponent,
  AttachmentsListComponent,
  ServiceDescriptionComponent,
  ReviewWorkflowComponent,
  ActionButtonsComponent,
  ExpressionOfInterestModalComponent
];

const modules = [
  MatButtonModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatStepperModule,
  MatListModule,
  MatIcon,
  FormsModule,
  MatStep,
  ReactiveFormsModule,
  MatCardModule,
  MatProgressBarModule,
  MatChip,
  MatChipsModule,
  MatMenuModule,
  MatToolbarModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatDialogModule,
  MatDividerModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatExpansionModule
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    ...modules,
    CommonModule,
    CoreModule
  ],
  exports: [
    ...components,
    ...modules,
    CoreModule
  ],
  providers: [
    
  ]
})
export class SharedModule { }
